import React from "react";
import useViewportDimensions from "../../../hooks/viewport/useViewportDimensions";

export type UseSelectSizeToFitScreenProps = {
  optionsCount: number;
  maxSize: number;
  minSize: number;
  size: number | undefined;
};

const EXTRA_SMALL_SCREEN = (height: number) => height <= 500;
const SMALL_SCREEN = (height: number) => height > 501 && height <= 700;
const MEDIUM_SCREEN = (height: number) => height > 701 && height <= 850;
const LARGE_SCREEN = (height: number) => height > 851 && height <= 950;
const EXTRA_LARGE_SCREEN = (height: number) => height > 951 && height <= 1101;

const S_SIZE = 15;
const M_SIZE = 20;
const L_SIZE = 25;
const XL_SIZE = 30;
const XXL_SIZE = 40;

const useSelectSizeToFitScreen = ({
  optionsCount,
  maxSize,
  minSize,
  size,
}: UseSelectSizeToFitScreenProps) => {
  const { y } = useViewportDimensions();

  const defaultSize =
    size ?? Math.max(Math.min(optionsCount, maxSize), minSize);

  const getMinSize = (sizeForScreen: number) =>
    Math.min(sizeForScreen, defaultSize);

  if (EXTRA_SMALL_SCREEN(y)) return defaultSize;

  if (SMALL_SCREEN(y)) return getMinSize(S_SIZE);

  if (MEDIUM_SCREEN(y)) return getMinSize(M_SIZE);

  if (LARGE_SCREEN(y)) return getMinSize(L_SIZE);

  if (EXTRA_LARGE_SCREEN(y)) return getMinSize(XL_SIZE);

  return getMinSize(XXL_SIZE);
};

export default useSelectSizeToFitScreen;
